<!-- src/views/MailerView.vue -->
<template>
  <MailerWorkspace />
</template>

<script setup>
import MailerWorkspace from "@/components/mailer/MailerWorkspace.vue";
</script>
